document.addEventListener("DOMContentLoaded", () => {

  [].slice.call(document.querySelectorAll(" .faq-item__question")).forEach(function (element) {
    element.onclick = function (event) {
      var parent = event.target.parentElement;
      parent.classList.contains("faq-item--active")
        ? parent.classList.remove("faq-item--active")
        : parent.classList.add("faq-item--active")
    }
  });

  [].slice.call(document.querySelectorAll(".faq-parent")).forEach(function (element) {
    const allNames = [].slice.call(element.querySelectorAll(".faq-name"));
    const allToggles = [].slice.call(element.querySelectorAll(".faq-toggle__question"));
    if (!allToggles.length || !allNames.length) {
      return
    }
    function toggleIndex(dataIndex) {
      allNames.forEach(function(nameElement) {
        nameElement.dataset.index === dataIndex
          ? nameElement.classList.add("faq-name--active")
          : nameElement.classList.remove("faq-name--active")
      });
      allToggles.forEach(function(toggleQuestionElement) {
        var parent = toggleQuestionElement.parentElement;
        parent.dataset.index === dataIndex
          ? parent.classList.add("faq-toggle--active")
          : parent.classList.remove("faq-toggle--active")
      });
    }
    allNames.forEach(function (nameElement) {
      nameElement.onclick = function () {
        toggleIndex(nameElement.dataset.index);
      }
    })
    allToggles.forEach(function (toggleQuestionElement) {
      toggleQuestionElement.onclick = function () {
        var parent = toggleQuestionElement.parentElement;
        toggleIndex(parent.dataset.index);
      }
    })
  });

})